import { buildServiceAPI, createAPI } from './requests.js';
export { drainPages } from '@debbie/common/dist/index.js';
// To be deprecated
export const collectionEngine = buildServiceAPI('/collection-engine');
export const IAM = createAPI('/iam');
export const collectionEngineV1 = createAPI('/collection-engine/v1');
export const integrations = createAPI('/integrations/v1');
//# sourceMappingURL=apis.js.map